import type { FC } from "react";

import styled, { keyframes } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const LoaderListItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
LoaderListItemsWrapper.displayName = "LoaderListItemsWrapper";

interface ITextProps {
    textSize?: "medium" | "large";
}

const LoaderListItemsTitle = styled.div<ITextProps>`
    line-height: 24px;
    margin-bottom: 12px;
    color: #2a3e52;
    width: 485px;
    text-align: center;
    font-weight: ${({ textSize = "medium" }) => (textSize === "large" ? "bold" : 500)};
    font-size: ${({ textSize = "medium" }) => (textSize === "large" ? "26px" : "20px")};
`;
LoaderListItemsTitle.displayName = "LoaderListItemsTitle";

const LoaderListItemsSubtitle = styled.div<ITextProps>`
    color: rgba(42, 62, 82, 0.6);
    text-align: center;
    line-height: 18px;
    width: 485px;
    font-weight: 400;
    font-size: ${({ textSize = "medium" }) => (textSize === "large" ? "16px" : "14px")};
`;
LoaderListItemsSubtitle.displayName = "LoaderListItemsSubtitle";

const bulletAnimationMove = keyframes`
  0% {
        top: 0;
        opacity: 0;
        transform: scale(0.8);
      }
      20% {
        top: 32px;
        opacity: 1;
        transform: scale(1);
      }
      40% {
        top: 64px;
      }
      60% {
        top: 96px;
      }
      80% {
        top: 128px;
        opacity: 1;
        transform: scale(1);
      }
      100% {
        top: 160px;
        opacity: 0;
        transform: scale(0.9);
      }
`;

const BulletContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    width: 132px;
    height: 177px;
    text-align: center;
`;

const BulletItem = styled.div`
    animation: ${bulletAnimationMove} 4s ease-out infinite;
    position: absolute;
    display: block;
    opacity: 0;
    top: 0;
    left: 0;
    animation-delay: 0s;
    &:nth-child(2) {
        animation-delay: 800ms;
    }
    &:nth-child(3) {
        animation-delay: 1600ms;
    }
    &:nth-child(4) {
        animation-delay: 2400ms;
    }
    &:nth-child(5) {
        animation-delay: 3200ms;
    }
`;

const Bullet = styled.div`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-bottom: 6px;
    background-color: ${colorsPalettes.carbon[100]};
`;

const BulletsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100px;
    margin-left: 12.5px;
`;

const LoaderListBulletsContainer = styled.div`
    height: 457px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const LoaderListBullets: FC<any> = ({ title, subtitle }) => (
    <LoaderListItemsWrapper>
        <BulletContainer>
            {[1, 2, 3, 4, 5].map((i) => (
                <BulletItem key={`bullet-${i}`}>
                    <BulletsContainer>
                        <Bullet />
                        <Bullet />
                        <Bullet />
                        <Bullet />
                    </BulletsContainer>
                </BulletItem>
            ))}
        </BulletContainer>
        <LoaderListItemsTitle>{title}</LoaderListItemsTitle>
        <LoaderListItemsSubtitle>{subtitle}</LoaderListItemsSubtitle>
    </LoaderListItemsWrapper>
);

export const LoaderListBulletsWrapper = (props: FixmeType) => {
    return (
        <LoaderListBulletsContainer>
            <LoaderListBullets {...props} />
        </LoaderListBulletsContainer>
    );
};
